import React from "react";
import { Box } from "@mui/material";
import { getDealLabel } from "../helpers/dealHelpers";

export default function DealBadge({ product }) {
  const label = getDealLabel(product);

  if (!label) return null;

  return (
    <Box
      sx={{
        position: "absolute",
        top: 10,
        left: 10,
        backgroundColor: "#D81B60",
        color: "white",
        px: 1.7,
        py: 0.7,
        borderRadius: "999px",
        fontSize: "14px",
        fontWeight: 700,
        zIndex: 5,
        minWidth: 55,
        textAlign: "center",
        boxShadow: "0 2px 6px rgba(0,0,0,0.12)",
      }}
    >
      {label}
    </Box>
  );
}